var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("v-data-table", {
    attrs: {
      headers: _vm.headers,
      "footer-props": { itemsPerPageOptions: [10, 25] },
      items: _vm.machines,
      loading: _vm.loading,
      "loading-text": "Loading... Please wait",
    },
    scopedSlots: _vm._u([
      {
        key: "footer.page-text",
        fn: function (props) {
          return [
            _vm._v(
              " " + _vm._s(props.pageStart) + "-" + _vm._s(props.pageStop) + " "
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }